import {useEffect} from 'react';
import {useSetRecoilState, atom} from 'recoil';

export const userGroupsState = atom({
   key: 'userGroupsStateKey',
   default: {username: '', groups: [], signOut: undefined},
});

export default function AuthenticatedUser({authState, children}) {
   const setUserGroups = useSetRecoilState(userGroupsState);

   useEffect(() => {
      if (authState) {
         const groups = authState?.user?.signInUserSession?.idToken?.payload?.['cognito:groups'] ?? [];
         setUserGroups({username: authState?.user?.username, groups, signOut: authState.signOut});
      }
   }, [authState, setUserGroups]);

   if (authState) {
      return children;
   } else {
      return null;
   }
}
